import React from 'react';
import { SimulationWarning } from '../types';

interface SimulationWarningsProps {
  warnings?: SimulationWarning[];
}

export function SimulationWarnings({ warnings }: SimulationWarningsProps) {
  if (!warnings || warnings.length === 0) {
    return null;
  }

  return (
    <div className="mb-4">
      {warnings.map((warning, index) => (
        <div key={`${warning.issue_type}-${index}`} className="alert alert-warning py-2 small mb-2">
          {warning.msg}
        </div>
      ))}
    </div>
  );
}
